/* Rosela Cover Stick - shade-per-stick bundle, add-all-lines, straight to checkout.

   Every stick has its own shade select in the panel under the tier cards. Dawn's own variant
   picker is hidden on this page but still in the DOM: stick 1's select is pushed into it and
   a change event dispatched, so Dawn keeps updating the gallery, price, URL and the form's
   hidden id exactly as it always did. Sticks 2 and 3 follow stick 1 until touched.

   On submit this product's existing cart lines are removed (replace, don't stack), then
   every chosen line goes to /cart/add.js in ONE request, then the customer is sent to
   checkout. The price break is Shopify's own automatic discounts, so cart and checkout show
   a real discount line. Coming back from checkout restores the page from the back-forward
   cache with the button still disabled; the pageshow handler re-arms it.

   Speed: the cart is read once at page load and the click takes the shortest path that
   keeps "replace, don't stack": empty cart -> one /cart/add.js then /checkout (keeps the
   add-to-cart pixel event); cart holding only this product -> cart permalink, zero requests;
   anything else in the cart, or cart unknown -> the careful three-step path.

   Submit is intercepted on document in the CAPTURE phase: Dawn binds its listener on the
   form itself, and a capture listener on an ancestor runs first. */
(function () {
  var ROOT = '[data-stick-bundle]';
  var FORM = 'form[action*="/cart/add"]';

  function base() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    catch (e) { return '/'; }
  }

  function productForm() {
    var forms = document.querySelectorAll(FORM);
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]')) return forms[i];
    }
    return forms[0] || null;
  }

  function idInput(form) { return form ? form.querySelector('[name="id"]') : null; }

  function quantityField(form) {
    if (!form) return null;
    var el = form.querySelector('input[name="quantity"]');
    if (el) return el;
    el = document.createElement('input');
    el.type = 'hidden';
    el.name = 'quantity';
    el.value = '1';
    form.appendChild(el);
    return el;
  }

  function selectedQty(root) {
    var i = root.querySelector('input[name="stick-qty"]:checked');
    return i ? parseInt(i.value, 10) || 1 : 1;
  }

  function slot(n) { return document.querySelector('[data-sb-shade="' + n + '"]'); }
  function slots() { return document.querySelectorAll('[data-sb-shade]'); }

  /* Lines to add: one per stick up to the chosen tier, merged by variant. */
  function lines(root) {
    var qty = selectedQty(root);
    var counts = {};
    slots().forEach(function (s) {
      var n = parseInt(s.getAttribute('data-sb-shade'), 10);
      if (n > qty) return;
      counts[s.value] = (counts[s.value] || 0) + 1;
    });
    return Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });
  }

  function mixed(root) { return lines(root).length > 1; }

  /* Shop Pay / dynamic checkout only ever reads the form's own id and quantity, so it would
     silently drop the other shades. Hide it whenever the bundle is mixed. */
  function dynamicCheckout(hide) {
    var el = document.querySelector('.shopify-payment-button');
    if (el) el.style.display = hide ? 'none' : '';
  }

  /* Push stick 1's shade into Dawn's hidden picker so Dawn does its usual work (gallery,
     price, URL, form id). Falls back to writing the form id directly if the picker is gone. */
  var pushing = false;
  function pushToDawn(variantId) {
    var s1 = slot(1);
    var opt = s1 ? s1.querySelector('option[value="' + variantId + '"]') : null;
    var optionValue = opt ? opt.getAttribute('data-option') : null;
    var dawn = document.querySelector('variant-selects select, variant-selects .select__select');
    pushing = true;
    try {
      if (dawn && optionValue !== null && dawn.value !== optionValue) {
        dawn.value = optionValue;
        dawn.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!dawn) {
        var id = idInput(productForm());
        if (id) { id.value = String(variantId); id.disabled = false; }
      }
    } finally {
      window.setTimeout(function () { pushing = false; }, 0);
    }
  }

  function refresh(root) {
    var form = productForm();
    var qty = selectedQty(root);
    document.querySelectorAll('[data-sb-slot]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-sb-slot'), 10);
      el.hidden = n > qty;
    });
    var title = document.querySelector('[data-sb-title]');
    if (title) title.textContent = qty > 1 ? 'Shade for each stick' : 'Shade';
    var l1 = document.querySelector('[data-sb-slot="1"] [data-sb-slot-label]');
    if (l1) l1.textContent = qty > 1 ? 'Stick 1' : 'Shade';

    var s1 = slot(1);
    var first = s1 ? s1.value : null;
    slots().forEach(function (s) {
      if (s !== s1 && !s.dataset.touched && first) s.value = first;
    });
    var q = quantityField(form);
    if (q && q.value !== String(qty)) {
      q.value = String(qty);
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }
    dynamicCheckout(mixed(root));
    error('');
  }

  /* Dawn changed the variant on its own (URL ?variant=, a swatch, back/forward). Mirror it
     into stick 1 unless the customer has already chosen stick 1 themselves. */
  function pullFromDawn(root) {
    if (pushing) return;
    var id = idInput(productForm());
    var s1 = slot(1);
    if (!id || !s1 || !id.value) return;
    if (s1.value !== id.value && s1.querySelector('option[value="' + id.value + '"]')) {
      s1.value = id.value;
      refresh(root);
    }
  }

  function error(msg) {
    var el = document.querySelector('[data-sb-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('is-on', !!msg);
  }

  /* Button state. The resting label is remembered once so it can always be put back. */
  function submitButton(form) { return form ? form.querySelector('[name="add"]') : null; }
  function rememberLabel(form) {
    var btn = submitButton(form);
    var label = btn ? btn.querySelector('span') : null;
    if (btn && label && !btn.dataset.sbLabel) btn.dataset.sbLabel = label.textContent.trim();
  }
  function busy(form, on) {
    var btn = submitButton(form);
    var label = btn ? btn.querySelector('span') : null;
    if (!btn) return;
    if (on) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Taking you to checkout';
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (label && btn.dataset.sbLabel) label.textContent = btn.dataset.sbLabel;
    }
  }

  function boot() {
    var root = document.querySelector(ROOT);
    if (!root || root.dataset.sbReady) return;
    root.dataset.sbReady = '1';
    rememberLabel(productForm());

    root.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'stick-qty') refresh(root);
    });
    slots().forEach(function (s) {
      s.addEventListener('change', function () {
        var n = parseInt(s.getAttribute('data-sb-shade'), 10);
        if (n === 1) pushToDawn(s.value); else s.dataset.touched = '1';
        refresh(root);
      });
    });

    /* Dawn sets the form id (a property, not an attribute) only after it has fetched the
       re-rendered section. Its pubsub event is the reliable signal; the retries cover Dawn
       builds without it. */
    if (typeof window.subscribe === 'function') {
      window.subscribe('variant-change', function () { pullFromDawn(root); });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
        [60, 350, 900].forEach(function (ms) {
          window.setTimeout(function () { pullFromDawn(root); }, ms);
        });
      }
    });

    pullFromDawn(root);
    refresh(root);
  }


  /* Cart knowledge, read once at load and again whenever the page is shown from the
     back-forward cache. It decides which of three checkout paths runs (see checkout()). */
  var cartState = null; /* Ajax cart object, or null while unknown */
  function readCart() {
    cartState = null;
    return fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; })
      .catch(function () { cartState = null; });
  }
  function cartHasOnly(pid) {
    if (!cartState || !cartState.items) return null;          /* unknown */
    for (var i = 0; i < cartState.items.length; i++) {
      if (cartState.items[i].product_id !== pid) return false; /* something else in there */
    }
    return true;                                                /* empty, or only this product */
  }
  function cartIsEmpty() { return !!(cartState && cartState.items && cartState.items.length === 0); }
  /* /cart/VARIANT:QTY[,VARIANT:QTY] makes Shopify build a fresh cart with exactly those
     lines and land on checkout in a single navigation. It replaces the whole cart, which is
     why it is only used when the cart holds nothing but this product. */
  function permalink(items) {
    return base() + 'cart/' + items.map(function (l) { return l.id + ':' + l.quantity; }).join(',');
  }

  /* Remove this product's existing lines so the chosen bundle replaces rather than stacks.
     Best effort: any failure here falls through to a normal add. */
  function clearProduct(pid) {
    if (!pid) return Promise.resolve();
    return fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {}, any = false;
        (cart.items || []).forEach(function (it) {
          if (it.product_id === pid) { updates[it.key] = 0; any = true; }
        });
        if (!any) return;
        return fetch(base() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () {});
  }

  function checkout(form, root) {
    rememberLabel(form);
    busy(form, true);
    error('');
    var pid = parseInt(root.getAttribute('data-product-id'), 10) || null;
    var items = lines(root);
    var only = pid ? cartHasOnly(pid) : null;

    if (items.length && only === true && !cartIsEmpty()) {
      window.location.href = permalink(items);
      return;
    }

    (cartIsEmpty() ? Promise.resolve() : clearProduct(pid))
      .then(function () {
        return fetch(base() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          /* Shopify answers 422 with a readable reason (a shade sold out, a quantity cap).
             Show it and hand the button back rather than pushing on to a broken checkout. */
          busy(form, false);
          error((res.body && (res.body.description || res.body.message)) || 'That combination could not be added. Please try again.');
          return;
        }
        window.location.href = base() + 'checkout';
      })
      .catch(function () {
        /* Network failure: fall back to a plain form post so nobody is stranded. It carries
           stick 1's shade at the chosen quantity, which is right whenever shades match. */
        busy(form, false);
        form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM)) return;
    var root = document.querySelector(ROOT);
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    checkout(form, root);
  }, true);

  /* Back from checkout: the page comes out of the back-forward cache mid-"busy". Re-arm. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var form = productForm();
    if (form) busy(form, false);
    readCart(); /* the cart changed at checkout; refresh what we know */
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  readCart();
})();
